/* tslint:disable */
/* eslint-disable */
/* @relayHash 29f487746d68b5d02ad9a399e8310f44 */

import { ConcreteRequest } from "relay-runtime";
export type NEW_USER_MODERATION = "BAN" | "PREMOD" | "%future added value";
export type UpdateEmailDomainInput = {
    clientMutationId: string;
    id: string;
    domain: string;
    newUserModeration: NEW_USER_MODERATION;
};
export type UpdateEmailDomainMutationVariables = {
    input: UpdateEmailDomainInput;
};
export type UpdateEmailDomainMutationResponse = {
    readonly updateEmailDomain: {
        readonly settings: {
            readonly emailDomainModeration: ReadonlyArray<{
                readonly id: string;
                readonly domain: string;
                readonly newUserModeration: NEW_USER_MODERATION;
            }>;
        };
        readonly clientMutationId: string;
    };
};
export type UpdateEmailDomainMutation = {
    readonly response: UpdateEmailDomainMutationResponse;
    readonly variables: UpdateEmailDomainMutationVariables;
};



/*
mutation UpdateEmailDomainMutation(
  $input: UpdateEmailDomainInput!
) {
  updateEmailDomain(input: $input) {
    settings {
      emailDomainModeration {
        id
        domain
        newUserModeration
      }
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "EmailDomain",
        "kind": "LinkedField",
        "name": "emailDomainModeration",
        "plural": true,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domain",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newUserModeration",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateEmailDomainMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateEmailDomainPayload",
                    "kind": "LinkedField",
                    "name": "updateEmailDomain",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Settings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateEmailDomainMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateEmailDomainPayload",
                    "kind": "LinkedField",
                    "name": "updateEmailDomain",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Settings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "29f487746d68b5d02ad9a399e8310f44",
            "metadata": {},
            "name": "UpdateEmailDomainMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '8175491f707f168d0e980f9598efa104';
export default node;
